<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="newprop" icon="new" bold :text="lang.button_New" :tooltip="lang.button_New"
            :disabled="newpropButtonStatus" />
          <action-button @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save"
            :disabled="saveButtonStatus" />
          <action-button v-if="!isAgent && !isPlugin" @click="exportCis" icon="exportCis" bold :text="lang.button_ExportCis"
            :tooltip="lang.button_ExportCis" :disabled="exportCisButtonStatus" />
          <action-button v-if="appConf.status.isHDL == true && (!isAgent && !isPlugin)" @click="exportHDL" icon="exportCis" bold
            :text="lang.button_ExportHDL" :tooltip="lang.button_ExportHDL" :disabled="exportHDLButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'
  import PartPropertiesType from '@/constants/PartPropertiesType'

  import Content from "@/components/PartManager/Views/Properties/Middle/Content/Content"

  import { mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {

      newpropButtonStatus: false,
      backButtonStatus: false,
      saveButtonStatus: false,
      exportCisButtonStatus: false,
      exportHDLButtonStatus: false,
      saving: false,
      propsTable: ""
    }
  },
  computed:{
    ...mapGetters({
      selectedTreeItemObject: 'selectedTreeItemObject',
      appConf: 'appConf',
      isAgent: 'isAgent',
      isPlugin: "isPlugin",
    }),
    propertyToSaving(){
      return this.$store.getters.propertyToSaving
    },
    categoryId(){
      if (this.selectedTreeItemObject.categoryId == undefined){
        return 1;
      }
      return this.selectedTreeItemObject.categoryId;
    },

  },
  created() {


  },
  methods: {
    validationTable(){

      
      this.propsTable
        .search("")
        .draw(); 
      
      let elements = document.querySelectorAll(".type-props, .browsable-props")
      
      if (elements.length == 0){
        const obj = {
          text: this.lang.alert_error_NoProperties,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
         
      let trigPartNumber = 0, trigSymbol = 0, trigFootprint = 0, trigRosh = 0, trigPspice = 0, trigValue = 0, trigType = 0, trigDescription = 0, trigHdlSymbol = 0, trigPackType = 0;
      const ob = {};
      for (let i = 0, lei = elements.length; i < lei; i++){
        
        //if (elements[i].dataset.origins === "own") {
          
          if (elements[i].value == PartPropertiesType.PARTNUMBER) {
            trigPartNumber++;
          }
          if (elements[i].value == PartPropertiesType.SYMBOL){
            trigSymbol++;
          }
          if (elements[i].value == PartPropertiesType.FOOTPRINT ){
            trigFootprint++;
          }
          if (elements[i].value == PartPropertiesType.ROHS){
            trigRosh++;
          }
          if (elements[i].value == PartPropertiesType.PSPICEMODEL){
            trigPspice++;
          }
          if (elements[i].value == PartPropertiesType.VALUE){
            trigValue++;
          }
          if (elements[i].value == PartPropertiesType.TYPE) {
            trigType++;
          }
          if (elements[i].value == PartPropertiesType.DESCRIPTION) {
            trigDescription++;
          }
          if (elements[i].value == PartPropertiesType.HDLSYMBOL) {
            trigHdlSymbol++;
          }
          if (elements[i].value == PartPropertiesType.PACKTYPE) {
            trigPackType++;
          }
          
          const temp = elements[i].id.split("_");
          
          
          if (temp[0] == "designation"){
            
            ob[temp[1]] = {}
            ob[temp[1]].designation = elements[i].value;
          }
          
          if (temp[0] == "browsable"){
            
            ob[temp[1]].browsable = elements[i].checked;
          }
        //}
        
        
        
        
      }
      
      for(let el in ob){
        
        if ((ob[el].designation == 0) && (ob[el].browsable == true)){
          const obj = {
            text: this.lang.alert_error_NotExposeAndBrowsable,
            time: 15,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);

          return false;
        }
      }
      
      let isTooMuch = true;
      let what = "";
      if (trigPartNumber > 1){
        isTooMuch = false;
        what = PartPropertiesType.PARTNUMBER;
      }
      if (trigSymbol > 1){
        isTooMuch = false;
        what = PartPropertiesType.SYMBOL;
      }
      if (trigFootprint > 1){
        isTooMuch = false;
        what = PartPropertiesType.FOOTPRINT;
      }
      if (trigRosh > 1){
        isTooMuch = false;
        what = PartPropertiesType.ROHS;
      }
      if (trigPspice > 1){
        isTooMuch = false;
        what = PartPropertiesType.PSPICEMODEL;
      }
      if (trigValue > 1){
        isTooMuch = false;
        what = PartPropertiesType.VALUE;
      }
      if (trigType > 1) {
        isTooMuch = false;
        what = PartPropertiesType.TYPE;
      }
      if (trigDescription > 1) {
        isTooMuch = false;
        what = PartPropertiesType.DESCRIPTION;
      }
      if (trigHdlSymbol > 1) {
        isTooMuch = false;
        what = PartPropertiesType.HDLSYMBOL;
      }
      if (trigPackType > 1) {
        isTooMuch = false;
        what = PartPropertiesType.PACKTYPE;
      }

      if (isTooMuch == false){
        const obj = {
          text: this.lang.alert_error_DuplicateProperty + " (" + what + ")",
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigPartNumber == 0){
        const obj = {
          text: this.lang.alert_error_NoPartNumber,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigValue == 0) {
        const obj = {
          text: this.lang.alert_error_NoValue,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigType == 0) {
        const obj = {
          text: this.lang.alert_error_NoType,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }


      return true;
    },
    save(){

      let _vue = this;

      let isValid = this.validationTable();

      
      if (!isValid){

        
        return

      }
     

      for (let i = 0, lei = this.propertyToSaving.length; i < lei; i++){

        this.propertyToSaving[i].categoryId = this.categoryId;


        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateProperty", this.propertyToSaving[i])
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){
            
                if (i + 1 == lei){

                  const obj = {
                    text: _vue.lang.alert_success_Update,
                    time: 5,
                    type: "success"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                  
                  //reload table
                  const reloadObj = {
                      status: true,
                      name: "FormPartPropertiesComponent"
                  }
                  _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }else{
                  
                }
   
              }else{
                

                const obj = {
                  text: _vue.lang.alert_error_Update,
                  time: 10,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            })
      }
      const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiComponent"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);

    },
    exportCis(){

      let vue = this;

      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_exposeToCIS")
      .then( result => {

        console.log(result)

        if (result.obj  == undefined){

          let fileName = "OMNYA.DBC";
          
          var a = document.createElement("a");
          a.href = URL.createObjectURL(result.data);
          a.download = fileName;
          
          document.body.appendChild(a);
          
          a.click();
          document.body.removeChild(a);

          const obj = {
            text: vue.lang.alert_success_CIS,
            time: 10,
            type: "success"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }else{
          const obj = {
            text: vue.lang.alert_error_CIS + ": " + result.obj.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);


        }  
      
      })
    },
    exportHDL(){

      let vue = this;
      

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_exposeToHDL")
      .then( result => {

        console.log(result)

        if (result.obj == undefined){

          let fileName = "PTF_TABLES.ZIP";
        
          let a = document.createElement("a");
          a.href = URL.createObjectURL(result.data);
          a.download = fileName;
          
          document.body.appendChild(a);
          
          a.click();
          document.body.removeChild(a);

          const obj = {
            text: vue.lang.alert_success_HDL,
            time: 10,
            type: "success"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }else{
          const obj = {
            text: vue.lang.alert_error_HDL + ": " + result.obj.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);


        }

       
      
      })
    },
    newprop(){
      
      let _vue = this;

      let funcYes = function(e){

        let form = _vue.$store.getters.createPropertyForm;


        let isRequiredOnRequest = form.checked.includes("isRequiredOnRequest");
        let isRequiredOnRelease = form.checked.includes("isRequiredOnRelease");
        let isRevisionChanging = form.checked.includes("isRevisionChanging");
        let isSearchString = form.checked.includes("isSearchString");
        let isNotForDerive = form.checked.includes("isNotForDerive");
        let cisBrowsable = form.checked.includes("cisBrowsable");

        let obj = {
          categoryId: _vue.$store.getters.selectedTreeItemObject.categoryId,
          name: form.name,
          type: form.type,
          isRequiredOnRequest: isRequiredOnRequest,
          isRequiredOnRelease: isRequiredOnRelease,
          isRevisionChanging: isRevisionChanging,
          isSearchString: isSearchString,
          isNotForDerive: isNotForDerive,
          cisBrowsable: cisBrowsable,
          cisDesignation: form.cisDesignation,
          hdlDesignation: form.hdlDesignation,
          libraryCategoryId: form.libraryCategoryId
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_createProperty", obj)
        .then(function(result) {
          
          console.log(result)

          if (result.status == "OK"){

            if (result.data != null){
              const obj = {
                text: _vue.lang.alert_success_NewProperty,
                time: 10,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              const reloadObj = {
                status: true,
                name: "FormPartPropertiesComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            }else{
              const obj = {
                text: _vue.lang.alert_error_NewProperty + ".",
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }

          }else{
            const obj = {
              text: _vue.lang.alert_error_NewProperty + ": " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          }

          

        })

      }

      var obj = {
        
        text: "",
        type: "new_property",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_NewProperty,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);


    },
    back(){

      let to = this.$route.query.from;

      
      this.$store.commit("BACKROUTINGDATA");
      

      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/Properties/Middle/Middle.vue